var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tip),expression:"tip"}]},[_vm._t("default"),(_vm.tip && _vm.showIcon)?_c('i',{staticClass:"fas fa-info-circle"}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }